import { Box } from "grommet";
import React from "react";
import StandardColors from "../../../../../../../util/StandardColors";
import "./ChartCard.css";

type ChartCardProps = {
  title: string;
  chartComponent: () => JSX.Element;
};

const ChartCard = ({ title, chartComponent }: ChartCardProps) => (
  <Box
    elevation="xsmall"
    round="small"
    direction="column"
    //pad={{ bottom: "30px", top: "30px" }}
    //pad={"medium"}
    align="center"
    fill
    background={StandardColors.white}
    justify="between"
  >
    {/* <p className="chart-card-title-text">{title}</p> */}
    {chartComponent()}
  </Box>
);

export default ChartCard;
